var __TEMP__ = require('./_ListCache.js');var ListCache = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stackClear.js');var stackClear = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stackDelete.js');var stackDelete = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stackGet.js');var stackGet = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stackHas.js');var stackHas = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stackSet.js');var stackSet = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = Stack;
